module.exports = __webpack_public_path__ + "img/tit1@2x.86928553.png";